import { ITrail } from '../../state/types';
import { makeTrailFetch } from './_shared/fetchMakers';
import { normalizeSingleEntity } from './_shared/normalizers';
import { makeTrailUrl } from './_shared/urlMakers';

export const fetchTrail = makeTrailFetch<ITrail>(
    makeTrailUrl,
    normalizeSingleEntity
);
